export default __webpack_public_path__ + "media/images/icons/icon-arrow-pagination-next-78e7c1d12c15d0b629a75421368cdac4.svg";